// Libs
import React, { useState, useContext, useEffect } from "react";
import { useObserver, useRouter } from "@shoothill/core";
import { Link as RouterLink } from "react-router-dom";
import { Box, Typography, Link } from "@material-ui/core";
import { StoresContext, Stores } from "Globals/Stores";
import { StyledButton } from "Globals/Styles/ButtonStyles";
import { AppUrls } from "AppUrls";

export const ThankYouForSubmittingView: React.FC = () => {
    const storesContext = useContext<Stores>(StoresContext);

    const getEditableCopyByRouteAndPlaceholderNumber = (route: string, placeholderNumber: number) => {
        let editableCopyRoute = storesContext.Domain.editableCopyRoutes.find((r) => r.route === route);

        if (editableCopyRoute !== undefined) {
            let editableCopyRouteId: string = editableCopyRoute.id;
            return storesContext.Domain.editableCopies.find((c) => c.routeId === editableCopyRouteId && c.placeholderNumber === placeholderNumber)?.copyValue as string;
        }

        return "";
    };

    return useObserver(() => (
        <>
            <Box style={{ padding: "40px 35px" }}>
                <Typography style={{ fontSize: "28px", fontWeight: "bold" }}>{getEditableCopyByRouteAndPlaceholderNumber("/thank-you", 1)}</Typography>
                <Typography variant="body2">{getEditableCopyByRouteAndPlaceholderNumber("/thank-you", 2)}</Typography>
                <hr style={{ margin: "30px 0px" }} />
                <Box style={{ display: "flex", margin: "15px 0px" }}>
                    <Link component={RouterLink} to={AppUrls.Client.Dashboard}>
                        <StyledButton>Go to dashboard</StyledButton>
                    </Link>
                    <StyledButton onClick={() => storesContext.Domain.AccountStore.Logout()}>Log out</StyledButton>
                </Box>
            </Box>
        </>
    ));
};
